function isValid(email: string) {
	return /^[\wа-яА-ЯёЁ]+([.-]?[\wа-яА-ЯёЁ]+)*@[\wа-яА-ЯёЁ]+([.-]?[\wа-яА-ЯёЁ]+)*(\.[\wа-яА-ЯёЁ]{2,})+$/.test(email);
}

function isValidEmail(email: string) {
	return /^(?![-.])(?=.*[A-Z0-9])[A-Z0-9._%+-]*(?<![-.])@[A-Z0-9]+[A-Z0-9.-]*[A-Z0-9]+\.[A-Z]{2,}$/i.test(email);
}

function toSecure(email: string) {
	const [login = '', domain = ''] = email.split('@');
	let newLogin = `${login.charAt(0)}***`;
	if (login.length > 2) {
		newLogin += `${login.charAt(login.length - 1)}`;
	}

	return `${newLogin}@${domain}`;
}

export const email = {isValid, toSecure, isValidEmail};
